import { Navigate } from 'react-router';

import { MY_SORARE_OFFERS_RECEIVED } from '@sorare/core/src/constants/__generated__/routes';

const Redirect = () => {
  return <Navigate to={MY_SORARE_OFFERS_RECEIVED} replace />;
};
export default Redirect;
